const state = {
  subscriptions: [],
  pagination: {},
  pending: false,
  errors: {},
}

const getters = {}

const actions = {
  getSubscriptions({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', true)

      this.api.items
        .getItems(type, payload)
        .then(({ data }) => {
          commit('GET_SUBSCRIPTIONS_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          commit('GET_SUBSCRIPTIONS_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
  deleteSubscription({ commit, rootState }, subscriptionId) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', true)

      this.api.item
        .removeItem(type, subscriptionId)
        .then(({ data }) => {
          if (data && data.errors) {
            commit('DELETE_SUBSCRIPTION_FAIL', data.errors)
            resolve()
          }
          commit('DELETE_SUBSCRIPTION_SUCCESS', data)
          resolve(data)
        })
        .catch(error => {
          commit('DELETE_SUBSCRIPTION_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
}

const mutations = {
  SET_PENDING(state, val) {
    state.pending = val
  },
  GET_SUBSCRIPTIONS_SUCCESS(state, { pagination, subscriptions }) {
    state.errors = {}
    state.subscriptions = subscriptions
    state.pagination = pagination
  },
  GET_SUBSCRIPTIONS_FAIL(state, errors) {
    state.errors = errors
  },
  DELETE_SUBSCRIPTION_SUCCESS(state) {
    state.errors = {}
  },
  DELETE_SUBSCRIPTION_FAIL(state, errors) {
    state.errors = errors
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
